import React, { useEffect } from "react";
import logo from '../src/assets/logo-1.png';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Product from './components/Product';
import AOS from "aos";
import "aos/dist/aos.css";
function App() {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out", 
      once: true,
    });
  }, []);
  return (
    <div className="App">
    
      <Product/>
    </div>
  );
}

export default App;
